// Maps a coterieType (subject) to its Playful Frost tint, ink accent, and emblem
// icon, so homework / assignment cards get the design system's subject-coded look
// (a soft pastel tint + a colored left accent + the subject emblem icon).
// Tints mirror the --subject-* tokens in index.css. Falls back to teal for
// unknown/aggregate types.

export interface SubjectStyle {
  tint: string;
  ink: string;
  icon: string;
}

const SUBJECT_STYLE_MAP: Record<string, SubjectStyle> = {
  MATHEMATICS: { tint: "#fee7d8", ink: "#C2541C", icon: "/achievements/coterie-type-mathematics.webp" },
  SCIENCE: { tint: "#f1e6ff", ink: "#7A4FBF", icon: "/achievements/coterie-type-science.webp" },
  PHYSICS: { tint: "#c7f2ef", ink: "#2E7D8A", icon: "/achievements/coterie-type-physics.webp" },
  CHEMISTRY: { tint: "#f1e6ff", ink: "#7A4FBF", icon: "/achievements/coterie-type-chemistry.webp" },
  BIOLOGY: { tint: "#e8fff3", ink: "#2E7D55", icon: "/achievements/coterie-type-biology.webp" },
  TURKISH: { tint: "#fff7d7", ink: "#9A7B0A", icon: "/achievements/coterie-type-turkish.webp" },
  LITERATURE: { tint: "#fff7d7", ink: "#9A7B0A", icon: "/achievements/coterie-type-literature.webp" },
  ENGLISH: { tint: "#f2f4f7", ink: "#5B6B7A", icon: "/achievements/coterie-type-english.webp" },
  HISTORY: { tint: "#e7f0ff", ink: "#2F6BC2", icon: "/achievements/coterie-type-history.webp" },
  GEOGRAPHY: { tint: "#ffd1c7", ink: "#B5552F", icon: "/achievements/coterie-type-geography.webp" },
  SOCIAL_STUDIES: { tint: "#e7f0ff", ink: "#2F6BC2", icon: "/achievements/coterie-type-social-studies.webp" },
  PHILOSOPHY: { tint: "#c9c7ff", ink: "#4F4FB0", icon: "/achievements/coterie-type-philosophy.webp" },
  GENERAL_CULTURE: { tint: "#f2f4f7", ink: "#5B6B7A", icon: "/achievements/coterie-type-general-culture.webp" },
  RELIGION_CULTURE_AND_ETHICS: { tint: "#ffe6f1", ink: "#A03A6B", icon: "/achievements/coterie-type-culture-and-religion-knowledge.webp" },
  LIFE_STUDIES: { tint: "#e8fff3", ink: "#2E7D55", icon: "/achievements/coterie-type-life-studies.webp" },
  PHYSICAL_EDUCATION: { tint: "#c7f2ef", ink: "#2E7D8A", icon: "/achievements/coterie-type-physical-education.webp" },
  TRAFFIC_SAFETY: { tint: "#ffd1c7", ink: "#B5552F", icon: "/achievements/coterie-type-traffic-safety.webp" },
};

const DEFAULT_SUBJECT_STYLE: SubjectStyle = {
  tint: "#E8F7FA",
  ink: "#0F899C",
  icon: "/achievements/coterie-type-total.webp",
};

export const retrieveSubjectStyle = (coterieType?: string): SubjectStyle =>
  (coterieType && SUBJECT_STYLE_MAP[coterieType]) || DEFAULT_SUBJECT_STYLE;

// Soft subject-tint gradient for a card background (design "lk-hw" treatment).
export const retrieveSubjectCardBackground = (coterieType?: string): string => {
  const { tint } = retrieveSubjectStyle(coterieType);
  return `linear-gradient(135deg, ${tint}, rgba(255, 255, 255, 0.72))`;
};
